import { isEmpty } from 'lodash-es';

app.directive('summarySectionPaymentInstruction', [
  '$uibModal',
  function ($uibModal) {
    const labelTemplate = `
      <label
        ng-show="showMultiInstructions"
        class="multi-checkout__payment-instructions__button"
        ng-click="showPaymentInstructions()">
        {{ "multi_checkout.summary_section.check_payment_instructions" | translate }}
      </label>
    `;

    return {
      restrict: 'E',
      template: labelTemplate,
      scope: {
        cartDeliveries: '<',
        paymentMethods: '<',
        deliveryOptions: '<',
      },
      link: function (scope) {
        scope.getPaymentIntroduction = () => {
          return scope.cartDeliveries.reduce((result, cart) => {
            const paymentMethod =
              scope.paymentMethods.find(
                (method) => method._id === cart.payment_id,
              ) || {};

            if (
              isEmpty(paymentMethod) ||
              !paymentMethod.show_description_on_checkout
            ) {
              return result;
            }

            const paymentIndex = result.findIndex(
              (payment) => payment.payment_id === cart.payment_id,
            );
            const deliveryOption =
              scope.deliveryOptions.find(
                (option) => option._id === cart.delivery_option_id,
              ) || {};

            if (paymentIndex >= 0) {
              result[paymentIndex].delivery_translations.push(
                deliveryOption.name_translations,
              );
              return result;
            }

            result.push({
              payment_id: paymentMethod._id,
              instructions_translations:
                paymentMethod.instructions_translations,
              instruction_media: paymentMethod.instruction_media,
              delivery_translations: [deliveryOption.name_translations],
            });

            return result;
          }, []);
        };

        scope.cartPaymentInfo = scope.getPaymentIntroduction();

        scope.showMultiInstructions = scope.cartPaymentInfo.length > 1;

        scope.showPaymentInstructions = () => {
          const newScope = scope.$new();
          newScope.paymentMethods = scope.cartPaymentInfo;
          $uibModal.open({
            templateUrl: require('../../../../../public/themes/shared/multi_checkout/template.summary-payment-instructions.modal.html'),
            windowClass: 'summary-section__payment-instruction__modal',
            scope: newScope,
            controller: [
              '$scope',
              '$filter',
              '$uibModalInstance',
              function ($scope, $filter, $uibModalInstance) {
                $scope.close = $uibModalInstance.close;

                scope.combineNames = function (nameTranslations) {
                  const names = nameTranslations.map((deliveryName) => {
                    return $filter('translateModel')(deliveryName);
                  });
                  return Array.from(new Set(names));
                };
              },
            ],
          });
        };
      },
    };
  },
]);
